import { useQuery } from '@tanstack/react-query'
import { useDI } from '@/di/DIContext'
import type { AgentId } from '@/domain/shared/Brand'

export function usePromotionLink() {
  const { affiliateService, sessionService } = useDI()
  const agentId = sessionService.getAgentId()

  return useQuery({
    queryKey: ['promotionLink', agentId],
    queryFn: () => affiliateService.getPromotionLink(agentId as AgentId),
    enabled: !!agentId,
    staleTime: 300000,
  })
}
